export const trimMaskedCardNumber = (maskedCreditCardNumber: string) =>
	maskedCreditCardNumber.substr(-5).replace(/[^0-9]/g, '*');
